import { render, staticRenderFns } from "./consanguinity.vue?vue&type=template&id=e0589ccc&"
import script from "./consanguinity.vue?vue&type=script&lang=js&"
export * from "./consanguinity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports